/**
 * Horse Guard FAQ accordion
 * Replacement for assets/z__jsFAQ.js
 */
(function () {
  window.PXUTheme.jsFAQ = {
    init: function () {
      var $faqHeading = $('.faq-accordion > dt > button');

      $('.faq-accordion > dd').attr('aria-hidden', true);
      $faqHeading.attr('aria-expanded', false);

      $faqHeading
        .off('click.pxuFaq')
        .on('click.pxuFaq', function (event) {
          var $button = $(this);
          var $panel = $button.parent().next('dd');
          var isExpanded = $button.attr('aria-expanded') === 'true';

          event.preventDefault();
          event.stopImmediatePropagation();

          $button.attr('aria-expanded', !isExpanded);
          $panel.attr('aria-hidden', isExpanded).stop(true, true).slideToggle();

          return false;
        });

      window.PXUTheme.collapsibleRowUtil.init();
    },

    unload: function () {
      $('.faq-accordion > dt > button').off('.pxuFaq');
      window.PXUTheme.collapsibleRowUtil.unload();
    }
  };
}());
